// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1zOTS","enable":"Button_enable__NRL-M","Success":"Button_Success__2E2j_","Danger":"Button_Danger__2dyWI"};